import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconLayersBehind"><Path d="M4.75 3C4.33579 3 4 3.33579 4 3.75C4 4.16421 4.33579 4.5 4.75 4.5H19.25C19.6642 4.5 20 4.16421 20 3.75C20 3.33579 19.6642 3 19.25 3H4.75Z" fill="currentColor"/><Path d="M4.75 6C3.23122 6 2 7.23122 2 8.75V17.25C2 18.7688 3.23122 20 4.75 20H19.25C20.7688 20 22 18.7688 22 17.25V8.75C22 7.23122 20.7688 6 19.25 6H4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersBehind;
